/* FOODHUB - A11y fixes v2 : aria-labels élargis + dédup IDs récurrente */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function addLabels() {
    var pairs = [
      ['a.thb-secondary-area-item[href="/cart"], a[href="/cart"]', 'Panier'],
      ['.desktop-search-icon, [class*="search-icon"]', 'Rechercher'],
      ['.swym-wishlist, .h-wishlist-icon', 'Favoris'],
      ['.thb-secondary-my, a[href*="customer_account"], a[href*="/account"]', 'Mon compte'],
      ['a.social.instagram, a[href*="instagram.com"]', 'Instagram'],
      ['a.social.linkedin, a[href*="linkedin.com"]', 'LinkedIn'],
      ['a.social.facebook, a[href*="facebook.com"]', 'Facebook'],
      ['a.social.youtube, a[href*="youtube.com"]', 'YouTube'],
      ['a.social.tiktok, a[href*="tiktok.com"]', 'TikTok'],
      ['a.social.twitter, a[href*="twitter.com"], a[href*="x.com"]', 'X / Twitter'],
      ['a[href*="wa.me"], a[href*="whatsapp.com"]', 'WhatsApp'],
      ['a.social.wechat[href^="mailto"]', 'Nous écrire'],
      ['a[href^="mailto:"]:not([aria-label])', 'Email'],
      ['a[href^="tel:"]:not([aria-label])', 'Téléphone'],
      ['a[href="/"], a[href="' + location.origin + '/"]', 'Accueil FOODHUB'],
    ];
    pairs.forEach(function (p) {
      document.querySelectorAll(p[0]).forEach(function (a) {
        var t = (a.innerText || '').trim();
        if (t || a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) return;
        a.setAttribute('aria-label', p[1]);
      });
    });
    // Menu category links
    document.querySelectorAll('.thb-full-menu--link:not([aria-label])').forEach(function (a) {
      if ((a.innerText || '').trim()) return;
      var name = (a.getAttribute('href') || '').split('/').pop().replace(/-/g, ' ');
      if (name) a.setAttribute('aria-label', name);
    });
    // Side panel close
    document.querySelectorAll('cart-drawer button:not([aria-label]), .side-panel-close:not([aria-label]), .drawer-close:not([aria-label])').forEach(function (b) {
      if ((b.innerText || '').trim()) return;
      b.setAttribute('aria-label', 'Fermer');
    });
  }
  function dedupIds() {
    var seen = {};
    document.querySelectorAll('[id]').forEach(function (el) {
      var id = el.id;
      if (!id) return;
      if (seen[id]) {
        seen[id] += 1;
        el.id = id + '-' + seen[id];
      } else {
        seen[id] = 1;
      }
    });
  }
  function ensureH1() {
    if (document.querySelector('h1')) return;
    // Get page title for the visually-hidden h1
    var title = (document.title || '').split('–')[0].trim().split('|')[0].trim();
    if (!title) return;
    var h1 = document.createElement('h1');
    h1.textContent = title;
    h1.className = 'fh-sr-only-h1';
    h1.style.cssText = 'position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;';
    var main = document.querySelector('main, #MainContent, [role="main"]');
    if (main) main.insertBefore(h1, main.firstChild);
    else document.body.insertBefore(h1, document.body.firstChild);
  }
  function runAll() { addLabels(); dedupIds(); ensureH1(); }
  ready(runAll);
  // Re-run after a delay to catch late-injected elements (localization, etc.)
  setTimeout(runAll, 500);
  setTimeout(runAll, 1500);
  setTimeout(runAll, 3000);
})();
